import { useState, useEffect } from 'react';

interface LineConfig {
  text: string;
  accentLast?: boolean;
}

interface HeroAnimatedTitleProps {
  lines: LineConfig[];
  baseClass?: string;
  accentClass?: string;
  delay?: number;
  stagger?: number;
  lineGap?: number;
}

export default function HeroAnimatedTitle({
  lines,
  baseClass = '',
  accentClass = '',
  delay = 300,
  stagger = 40,
  lineGap = 200,
}: HeroAnimatedTitleProps) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), delay);
    return () => clearTimeout(timer);
  }, [delay]);

  let globalCharIndex = 0;

  return (
    <div className={baseClass}>
      {lines.map((line, li) => {
        const chars = line.text.split('');
        const lineStartIndex = globalCharIndex;
        globalCharIndex += chars.length + lineGap / stagger;

        return (
          <div key={li}>
            {chars.map((char, ci) => {
              const isAccent = line.accentLast && ci === chars.length - 1;
              const charDelay = lineStartIndex + ci;

              return (
                <span
                  key={ci}
                  className={isAccent ? accentClass : ''}
                  style={{
                    display: 'inline-block',
                    opacity: visible ? 1 : 0,
                    transform: visible ? 'translateY(0)' : 'translateY(24px)',
                    transition: `opacity 500ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${charDelay * stagger}ms, transform 500ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${charDelay * stagger}ms`,
                    willChange: 'opacity, transform',
                  }}
                >
                  {char === ' ' ? '\u00A0' : char}
                </span>
              );
            })}
          </div>
        );
      })}
    </div>
  );
}